import { Tag } from '@approvalmax/ui/src/components';
import { FC } from 'react';

import { tagConfig } from './TransactionStatusTag.constants';
import { TransactionStatusTagProps } from './TransactionStatusTag.types';

export const TransactionStatusTag: FC<TransactionStatusTagProps> = (props) => {
    const { status } = props;

    const config = tagConfig[status];

    if (!config) {
        return null;
    }

    const { children, color, outline } = config;
    const title = typeof children === 'string' ? children : undefined;

    return (
        <Tag color={color} outline={outline} size='xsmall' title={title}>
            {children}
        </Tag>
    );
};

TransactionStatusTag.displayName = 'TransactionStatusTag';
